import { PendingTimesheet } from '../models/pending-timesheets.model';

export class PendingTimesheetsLogic {
    static countSelectedTimesheets(timesheets: PendingTimesheet[]): number {
        return timesheets.filter((timesheet: PendingTimesheet) => timesheet.isSelected === true)?.length || 0;
    }
}
